import { ShepherdOptionsWithType, Tour } from 'react-shepherd';

export const tourOptions: Tour.TourOptions = {
  defaultStepOptions: {
    classes: '',
    scrollTo: { behavior: 'smooth', block: 'center' },
    modalOverlayOpeningPadding: 4,
    canClickTarget: false,
  },
  useModalOverlay: true,
};

const stepButtons = (t: (key: string) => string) => [
  {
    classes: 'cancel-btn p-0',
    text: t('plbTourOmit'),
    type: 'cancel',
  },
];

export const steps = (t: (key: string) => string) =>
  [
    {
      id: 'paymentLinkButtonStep',
      attachTo: {
        element: '.paymentLinkButton',
        on: 'top',
      },
      text: [
        `<h4 class="mb-3">${t('plbBadge')}</h4><p class="mb-4">${t(
          'plbTourMessage'
        )}`,
      ],
      buttons: stepButtons(t),
    },
  ] as ShepherdOptionsWithType[];
